export default __webpack_public_path__ + "static/media/fresh_squeezed_lemonade.10ab6cf9.JPG";